export const postMessage = (data, origin = "*") => {
    
    data = JSON.stringify(data);
    window.parent.postMessage(`${data}`, origin);
    if (window.opener) {
        window.opener.postMessage(`${data}`, origin)
    }
};
